import { Component, Input, OnInit } from '@angular/core';
import { DescriptionCard } from 'src/app/model/interfaces/description-card';
import { ContentService } from 'src/app/services/content.service';

@Component({
  selector: 'app-description-cards',
  templateUrl: './description-cards.component.html',
  styleUrls: ['./description-cards.component.scss']
})
export class DescriptionCardsComponent implements OnInit
{
    @Input('currentRoute') public currentRoute: string;

    public descriptionCards: DescriptionCard[];

    private contentService: ContentService;

    constructor(contentService: ContentService)
    {
        this.contentService = contentService;
    }

    public ngOnInit(): void
    {
        this.getDescritionCards();
    }

    public getDescritionCards(): void
    {
        this.descriptionCards = this.contentService.getDescriptionCardContent();
    }
}
